/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStammdatenTyp } from '../../models/lexplus-stammdaten-typ';

export interface StammdatenControllerExportAllV1$Params {
  typ: LexplusStammdatenTyp;
}

export function stammdatenControllerExportAllV1(http: HttpClient, rootUrl: string, params: StammdatenControllerExportAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerExportAllV1.PATH, 'get');
  if (params) {
    rb.path('typ', params.typ, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

stammdatenControllerExportAllV1.PATH = '/v1/stammdaten/export/{typ}';
